import { z } from 'zod';

// a place as the public map shows it (made from the published content: world-content.ts)
export const CityActivity = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  area: z.string().min(1),
  icon: z.string().min(1),
  position: z.tuple([z.number(), z.number()]),
  description: z.string(),
  things: z.array(z.string()),
  badge: z.string().optional(),
  comingSoon: z.boolean().optional(),
  visible: z.boolean(),
  sortOrder: z.number().int(),
});
export type CityActivity = z.infer<typeof CityActivity>;
export const CityActivitiesReply = z.object({ activities: z.array(CityActivity) });
export type CityActivitiesReply = z.infer<typeof CityActivitiesReply>;
